/* eslint-disable no-use-before-define,react-hooks/exhaustive-deps */
import React from 'react'
import { getState, Status, arrayFrom, ajax, fmt, } from '../twd/twd'

const Last = getState('order-ticket-open-orders.last', {
    ts: 0,
    openOrders: [],
    openOrdersCount: 0,
    openOrdersStatus: Status.NULL,
})

export const resetLastOpenOrdersInfo = ({ts=0} = {}) => {
    Last.reset()
    Last.set({
        ts,
        openOrders: [],
        openOrdersCount: 0,
        openOrdersStatus: Status.NULL,
    })
}

export default ({acctNo, ts}) => {

    const [openOrders, setOpenOrders_] = React.useState(Last.value.openOrders || [])
    const setOpenOrders = React.useCallback((openOrders) => {
        Last.set({openOrders})
        setOpenOrders_(openOrders)
    }, [])

    const [openOrdersCount, setOpenOrdersCount_] = React.useState(Last.value.openOrdersCount || [])
    const setOpenOrdersCount = React.useCallback((openOrdersCount) => {
        Last.set({openOrdersCount})
        setOpenOrdersCount_(openOrdersCount)
    }, [])

    const [openOrdersStatus, setOpenOrdersStatus_] = React.useState(Last.value.openOrdersStatus || Status.NULL)
    const setOpenOrdersStatus = React.useCallback((openOrdersStatus) => {
        Last.set({openOrdersStatus})
        setOpenOrdersStatus_(openOrdersStatus)
    }, [])


    React.useEffect(() => {(async () => {
        try {

            setOpenOrdersCount(0)

            if (!acctNo) {
                setOpenOrdersStatus(Status.NULL)
                return
            }

            setOpenOrdersStatus(Status.LOADING)

            const now = new Date()
            const firstDate = new Date(now.getFullYear() - 3, now.getMonth(), now.getDate())
            const { data:data_ } = await ajax({
                url: '/esb/portfolio/trades',
                method: 'POST',
                params: {
                    tradeRow: {
                        tradeStatus: ["OPEN_ORDER"],
                        type: "traderow",
                        acctNo: [acctNo],
                        tradeSubmitDateRange: `${fmt.mdy(firstDate)},${fmt.mdy(now)}`
                    },
                    sort: [{
                        field: "tradeSubmitDate",
                        direction: "DESC"
                    }],
                    pageNumber: 1,
                    resultsPerPage: 50,
                    excludeBlockOrders: true,
                    tradeSource: "ATSSOURCE"
                }
            })
            const data = await data_

            const rs = arrayFrom(data.rows)
            setOpenOrders(rs)
            setOpenOrdersCount(rs.length)
            setOpenOrdersStatus(Status.LOADED)

        } catch(e) {
            setOpenOrders([])
            setOpenOrdersCount(0)
            setOpenOrdersStatus(Status.FAILED_TO_LOAD)
        }
    })()}, [acctNo, ts])


    return {
        openOrders,
        openOrdersCount,
        openOrdersStatus,
    }

}